import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';

const DataEngineeringTechStack = () => {
    return (
        <div className="section-py bg-grey dark:bg-black overflow-x-hidden border-b"
        style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="dark:text-white">Tech Stack</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="Warehouses & Lakehouses">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-snowflake.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Snowflake"
                                            title="Snowflake"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Snowflake</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-amazon-redshift.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Amazon Redshift"
                                            title="Amazon Redshift"
                                            height={50}
                                            width={50}
                                        />                                        
                                        <p className="text-base font-semibold mb-0 dark:text-white">Amazon Redshift</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-google-bigquery.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google BigQuery"
                                            title="Google BigQuery"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google BigQuery</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-azure-synapse.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure Synapse"
                                            title="Azure Synapse"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure Synapse</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-oracle-adw.svg"
                                            className="img-fluid mb-2.5 !w-24"
                                            alt="Oracle ADW"
                                            title="Oracle ADW"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Oracle ADW</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-databricks.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Databricks"
                                            title="Databricks"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Databricks</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-awss3.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS S3"
                                            title="AWS S3"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS S3</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-azuredatalakestorage.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure Data Lake Storage"
                                            title="Azure Data Lake Storage"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure Data Lake Storage</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-google-cloud-storage.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google Cloud Storage"
                                            title="Google Cloud Storage"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google Cloud Storage</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-delta-lake.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Delta Lake"
                                            title="Delta Lake"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Delta Lake</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Data Integration & ETL/ELT">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-fivetran.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Fivetran"
                                            title="Fivetran"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Fivetran</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-airbyte.svg"
                                            className="img-fluid mb-2.5 !h-10"
                                            alt="Airbyte"
                                            title="Airbyte"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Airbyte</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-airflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Airflow"
                                            title="Apache Airflow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Airflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-dbt.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Dbt"
                                            title="Dbt"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Dbt</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-talend.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Talend"
                                            title="Talend"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Talend</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-informatica.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Informatica"
                                            title="Informatica"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Informatica</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-glue.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS Glue"
                                            title="AWS Glue"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS Glue</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-data-factory.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure Data Factory"
                                            title="Azure Data Factory"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure Data Factory</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-dataflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google Cloud Dataflow"
                                            title="Google Cloud Dataflow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google Cloud Dataflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-matillion.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Matillion"
                                            title="Matillion"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Matillion</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Streaming & Real-Time Data">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-kafka.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Kafka"
                                            title="Apache Kafka"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Kafka</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-confluent.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Confluent"
                                            title="Confluent"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Confluent</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-kinesis.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS Kinesis"
                                            title="AWS Kinesis"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS Kinesis</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-azure-event-hubs.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure Event Hubs"
                                            title="Azure Event Hubs"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure Event Hubs</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-pubsub.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google Pub/Sub"
                                            title="Google Pub/Sub"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google Pub/Sub</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-flink.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Flink"
                                            title="Apache Flink"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Flink</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-spark-streaming.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Spark Streaming"
                                            title="Spark Streaming"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Spark Streaming</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-kafka-connect.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Kafka Connect"
                                            title="Kafka Connect"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Kafka Connect</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-ksql.svg"
                                            className="img-fluid mb-2.5"
                                            alt="KSQL / ksqlDB"
                                            title="KSQL / ksqlDB"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">KSQL</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-amazon-msk.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Amazon MSK"
                                            title="Amazon MSK"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Amazon MSK</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Orchestration & Workflow Automation">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-airflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Airflow"
                                            title="Apache Airflow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Airflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-prefect.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Prefect"
                                            title="Prefect"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Prefect</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-dagster.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Dagster"
                                            title="Dagster"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Dagster</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-aws-step-function.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS Step Function"
                                            title="AWS Step Function"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS Step Function</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-google-cloud-composer.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google cloud Composer"
                                            title="Google cloud Composer"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google cloud Composer</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-azure-data-factory.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure data factory"
                                            title="Azure data factory"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure data factory</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-argo-workflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Argo workflow"
                                            title="Argo workflow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Argo workflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-kubeflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Kubeflow"
                                            title="Kubeflow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Kubeflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-astronomer.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Astronomer"
                                            title="Astronomer"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Astronomer</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Data Processing & Transformation Engines">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-spark.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Spark"
                                            title="Apache Spark"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Spark</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-presto.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Presto"
                                            title="Presto"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Presto</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-trino.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Trino"
                                            title="Trino"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Trino</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-hive.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Hive"
                                            title="Apache Hive"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Hive</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-dremio.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Dremio"
                                            title="Dremio"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Dremio</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-starburst.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Starburst"
                                            title="Starburst"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Starburst</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-beam.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Beam"
                                            title="Apache Beam"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Beam</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-bigquery-sql-engine.svg"
                                            className="img-fluid mb-2.5"
                                            alt="BigQuery SQL Engine"
                                            title="BigQuery SQL Engine"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">BigQuery SQL Engine</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-snowflake-snowpark.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Snowflake Snowpark"
                                            title="Snowflake Snowpark"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Snowflake Snowpark</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Governance, Cataloging & Data Quality">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-great-expectations.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Great Expectations"
                                            title="Great Expectations"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Great Expectations</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-monte-carlo.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Monte Carlo"
                                            title="Monte Carlo"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Monte Carlo</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-datafold.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Datafold"
                                            title="Datafold"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Datafold</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-anomalo.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Anomalo"
                                            title="Anomalo"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Anomalo</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-deequ.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Deequ"
                                            title="Deequ"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Deequ</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-soda.svg"
                                            className="img-fluid mb-2.5 !w-24"
                                            alt="Soda"
                                            title="Soda"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Soda</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-alation.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Alation"
                                            title="Alation"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Alation</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-collibra.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Collibra"
                                            title="Collibra"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Collibra</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-atlas.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Atlas"
                                            title="Apache Atlas"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Atlas</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-atlan.svg"
                                            className="img-fluid mb-2.5 !w-24"
                                            alt="Atlan"
                                            title="Atlan"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Atlan</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DataEngineeringTechStack;
